import {lang as german} from '/src/modules/language/german';
import {lang as english} from '/src/modules/language/english';
import {lang} from '/main';

/**
 * A function to choose the correct language strings
 * @param {string} lang
 * @return {object}
 */
export function language(lang) {
  switch (lang) {
    case 'de':
      return german;
    case 'en':
      return english;
    default:
      return english;
  }
}

/**
 * Function for text replacement from GeoJSON files
 * @param {string} nameString
 * @return {string|boolean}
 */
export function replaceTextPlaceholder(nameString) {
  if (nameString !== undefined) {
    let regex = new RegExp(/(\{(.*?)\})/g);
    if (nameString.search(regex) !== -1) {
      let result = nameString.match(regex);

      if (result !== null) {
        result.forEach((val) => {
          let valRegex = new RegExp(/\{(.*?)\}/g);
          nameString = nameString.replace(val, lang[val.replace(valRegex, '$1')]);
        });
      }
    }

    return nameString;
  } else {
    return false;
  }
}
